export default "__VITE_ASSET__6I2Ffftg__"